<a class="see-more-card pointer" [routerLink]="route">
    <img src="/assets/images/Cloud%201.png" class="see-more-card__clouds" alt=""/>
    <img src="/assets/icons/see_more_icon.png" class="see-more-card__icon" alt=""/>
    <span class="see-more-card__label">{{ displayLabel }}</span>
</a>
